<div id="target-detection" style="text-align: -webkit-center;text-align: -moz-center; margin-top: 3rem;"
  [ngClass]="{'no-cursor': started && !startButton}">

  <div class="card" style="margin: 16px; text-align: center; width: 70%; min-width: 30rem">

    <!--SPINNER WHILE LOADING PAGE-->
    <div *ngIf="loading" style="text-align: -webkit-center;text-align: -moz-center; padding: 2rem 0px">
      <mat-spinner diameter="30"></mat-spinner>
    </div>

    <!--ALREADY DONE TEST-->
    <div *ngIf="!done && charged2">
      <p style="font-size: x-large; font-weight: 500;"> {{'ALREADY_DONE_TEST' | translate}} </p>
    </div>

    <div *ngIf="done">
      <!--TITLE-->
      <h1 *ngIf='(!started || !demo)  && !finished' style="font-size: 3em;">{{'TD_T1' | translate}}</h1>
      <h1 *ngIf='(started && demo ) && !finished' style="font-size: 3em;">{{'TD_T2' | translate}}</h1>

      <div *ngIf="started && !demo">

        <!--BLOCKS INDICATION-->
        <p style="text-align:center; font-weight: 500;">
          {{'BLOCK' | translate}}: {{block+1}}/2
        </p>
        <p style="margin: 0;font-weight: 100;font-size: small;">{{'ROUND' | translate}}:
          {{displayedRound+1}}/{{totalTrials}}</p>

      </div>

      <div *ngIf="started">
        <p>{{'TD_P1' | translate}}</p>
        <p>{{'TD_P2' | translate}}</p>
        <p *ngIf="startButton">{{'TD_P13' | translate}}</p>
        <button *ngIf="startButton" mat-raised-button class="button" (click)="begin()" style="margin: 16px 0;">{{'START'
          | translate}}</button>
      </div>

      <div *ngIf="!started && !demoScreen && block === 0" style="text-align: -webkit-center;text-align: -moz-center;">

        <p>
          {{'TD_P3' | translate}}
        </p>
        <p>
          {{'TD_P4' | translate}}
        </p>
        <p>
          {{'TD_P5' | translate}}
        </p>
        <p>
          {{'TD_P6' | translate}}
        </p>
        <p> 
          {{'TD_I1' | translate}}
        </p>
        <p>
          {{'TD_P7' | translate}}
        </p>
        <div style="display: flex; justify-content: center; margin-top: 1rem; font-family: akzidenz-grotesk-roman; ">
          <div style=" font-size: large;">
            {{'SELECT_AUDIO' | translate}}
            <br />
            <mat-radio-group>
              <div style="display: flex; justify-content: start; margin-top: 5px; margin-left: 5px;">

                <mat-radio-button [checked]="audioSource === 'headphones'" (change)="setAudioType($event.value)"
                  value="headphones">
                  {{'HEADPH' | translate}}
                </mat-radio-button>
              </div>
              <div style="display: flex; justify-content: start; margin-top: 5px; margin-left: 5px;">
                <mat-radio-button [checked]="audioSource === 'speakers'" (change)="setAudioType($event.value)"
                  value="speakers">
                  {{'SPEAKERS' | translate}}
                </mat-radio-button>
              </div>
            </mat-radio-group>
          </div>
        </div>
        <button matTooltip="{{'AUDIO_TOOLTIP' | translate}}" [matTooltipDisabled]="audioSource" *ngIf="!started"
          mat-raised-button class="button" (click)="start()" [disabled]="!audioSource">
          {{'START' | translate}}
        </button>

      </div>

      <!--DEMO SCREEN-->
      <div *ngIf="!started && ready && demoScreen" style="text-align: -webkit-center;text-align: -moz-center;">
        <p>
          {{'TD_P8' | translate}}
        </p>
        <p>
          {{'TD_P9' | translate}}
        </p>
        <div style="display:flex; justify-content:center ;">
          <button *ngIf="!started" mat-raised-button class="button" (click)="redoDemo('slow')"
            style="margin-right: 3px;">{{'TD_B1' | translate}}</button>
          <button *ngIf="!started" mat-raised-button class="button" (click)="redoDemo('normal')"
            style="margin-right: 3px;">{{'TD_B2' | translate}}</button>
          <button *ngIf="!started" mat-raised-button class="button" (click)="startExperiment()">{{'START' |
            translate}}</button>
        </div>

      </div>

      <!--BETWEEN BLOCKS SCREEN-->
      <div *ngIf="!started && ready && !demoScreen && block === 1"
        style="text-align: -webkit-center;text-align: -moz-center;">
        <p>
          {{'TD_P10' | translate}}
        </p>
        <p>
          {{'TD_P11' | translate}}
        </p>
        <button *ngIf="!started" mat-raised-button class="button" (click)="startExperiment()">{{'START' |
          translate}}</button>
      </div>

      <!--FINISHED TEST-->
      <div *ngIf="finished" style="text-align: -webkit-center;text-align: -moz-center; padding: 2rem 0px">
        <p style="font-size: 1.5em; font-family: akzidenz-grotesk-light;">{{'SUCCESS_TEST' | translate}}</p>
      </div>

      <!--SPINNER WHILE LOADING PAGE-->
      <div *ngIf="started && !ready" style="text-align: -webkit-center;text-align: -moz-center; padding: 2rem 0px">
        <mat-spinner diameter="30"></mat-spinner>
      </div>
    </div>
  </div>



  <!--TEST VIEW-->
  <div *ngIf="started && ready" class="card"
    style="height: 20rem; background-color: #828282; width: 70%; min-width: 30rem; margin-bottom: 3rem;">

    <div *ngIf="getReady"
      style="font-size: 3rem; height: 100%; display: flex; flex-direction: column; justify-content: center;">
      {{'TD_P12' | translate}}
    </div>

    <div *ngIf="showCue || showFixation"
      style="height: 100%; display: flex; flex-direction: column; justify-content: center;">
      <div *ngIf="showCue">
        <div *ngIf="cue === 'left'">
          <mat-icon style="transform: scale(4);">arrow_back</mat-icon>
        </div>
        <div *ngIf="cue === 'right'">
          <mat-icon style="transform: scale(4);">arrow_forward</mat-icon>
        </div>
        <span *ngIf="cue === 'neutral'">
          <mat-icon style="transform: scale(4);">arrow_back</mat-icon>
          <mat-icon style="transform: scale(4);">arrow_forward</mat-icon>
        </span>
      </div>

      <div *ngIf="showFixation">
        <div style="font-size: 5rem">+</div>
      </div>

    </div>

    <div *ngIf="showStimulus" style="height: 100%; display: flex; flex-direction: column; justify-content: center;">

      <!--LEFT-->
      <div *ngIf="stimulusSide === 'left'" style="display: flex; justify-content: left; padding-left: 25px;">
        <!--DARKER BOTTOM-->
        <div>
          <img *ngIf="stimulusDarker === 'bottom'" src="../../../assets/circle_bottom.png"
            style="height: 146px; width: 150px;" (load)="completeRound()" />
        </div>
        <!--DARKER TOP-->
        <div>
          <img *ngIf="stimulusDarker === 'top'" src="../../../assets/circle_top.png"
            style="height: 146px; width: 150px;" (load)="completeRound()" />
        </div>
      </div>


      <!--RIGHT-->
      <div *ngIf="stimulusSide === 'right'" style="display: flex; justify-content: right; padding-right: 25px;">
        <!--DARKER BOTTOM-->
        <div>
          <img *ngIf="stimulusDarker === 'bottom'" src="../../../assets/circle_bottom.png"
            style="height: 146px; width: 150px;" (load)="completeRound()" />
        </div>
        <!--DARKER TOP-->
        <div>
          <img *ngIf="stimulusDarker === 'top'" src="../../../assets/circle_top.png"
            style="height: 146px; width: 150px;" (load)="completeRound()" />
        </div>
      </div>


    </div>
  </div>

</div>